import Vue from 'vue'
import {Message, MessageBox} from 'element-ui'
import searchJson from '@/utils/searchjson'; // 搜索储存json
import options from "@/utils/options";

Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

/*
* Function: unifiedCallInterface()
* Desc: 接口统一调用的方法（获取列表、提交表单）
* Date: 2022-12-07
* Author: jxx
* */
window.unifiedCallInterface = Vue.prototype.unifiedCallInterface = async function (Interface, params, callback) {
  let detail = await Interface(params);
  callback && callback(detail);
}

/*
* Function: tipsTemplate()
* Desc: 成功失败提示框
* Date: 2022-12-07
* Author: jxx
* */
window.tipsTemplate = Vue.prototype.tipsTemplate = async function (text, type, state, btnText, clearText, callback) {
  if (state == "1") {
    Message({
      message: text,
      type: type,
      offset: 200
    });
  } else if (state == "2") {
    MessageBox.alert(text, "提示", {
      confirmButtonText: btnText,
      callback: action => callback && callback()
    });
  } else if (state == "3") {
    MessageBox.confirm(text, "提示", {
      confirmButtonText: btnText,
      cancelButtonText: clearText,
      type: type
    })
    .then(() => callback && callback())
    .catch(() => {
      Message({
        type: 'info',
        message: '已取消',
        offset: 200
      });
    });
  }
}

/*
* Function: uploadImageSize()
* Desc: 校验上传文件的大小
* Date: 2022-12-07
* Author: jxx
* */
window.uploadImageSize = Vue.prototype.uploadImageSize = function (response) {
  const isLt5M = response.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    tipsTemplate("上传文件大小不能超过 5MB!", "error", "1");
  }
  return false
}

/*
* Function: uploadImageType()
* Desc: 校验上传文件的类型
* Date: 2022-12-07
* Author: jxx
* */
window.uploadImageType = Vue.prototype.uploadImageType = function (file, array) {
  const fileName = file.name;
  const fileType = fileName.substring(fileName.lastIndexOf("."));
  for (var i = 0; i < array.length; i++) {
    if (array.includes(fileType)) {
      return true
    } else {
      return false
    }
  }
}

/*
* Function: noneData()
* Desc: 暂无数据显示--
* Date: 2022-12-07
* Author: jxx
* */
window.noneData = Vue.prototype.noneData = function (data) {
  if ((data === null || data === undefined || data === "" || data.length === 0) && ((typeof(data)) !== "number" && (typeof(data)) !== "boolean")) {
    return "--"
  }
  return data;
}

/*
* Function: scrollerHeight()
* Desc: 动态设置表格高度
* Date: 2023-04-23
* Author: jxx
* */
let queryHeight = ""
let blockHeight = ""
let moneyHeight = ""
window.getObjHeight = Vue.prototype.getObjHeight = function (queryH, blockH, moneyH) {
  queryHeight = queryH;
  blockHeight = blockH;
  moneyHeight = moneyH
}
window.onresize = function() {
  setTimeout(() => {
    setObjHeight()
  }, 400)
}

window.setObjHeight = Vue.prototype.setObjHeight = function () {
  let mainHeight = document.getElementById("main").offsetHeight;
  let tabsHeight = document.getElementById("tabPage").offsetHeight;
  let tableRefH = document.getElementById("tableRefH");

  // 检查所有需要的元素是否存在
  if (!mainHeight || !tabsHeight || !tableRefH || !queryHeight || !moneyHeight || !blockHeight) {
    return;
  }

  let fullHeight = mainHeight - tabsHeight - queryHeight.clientHeight - 66;
  let ObjHs = fullHeight - moneyHeight.clientHeight - blockHeight.clientHeight + "px";
  document.getElementById("tableRefH").style.height = ObjHs;
}

window.onload = function() {
  setTimeout(() => {
    setObjHeight()
  }, 400)
}

/*
* Function: scrollerHeight()
* Desc: 下载中心搜索条件
* Date: 2023-04-23
* Author: jxx
* */
window.typeText = Vue.prototype.typeText = function (type) {
  let obj = {};
  switch (type) {
    case 1:
      obj = {
        "orderNo": "流水号：",
        "merchantName": "商户名称：",
        "bankAccountName": "账户名称：",
        "startCreateTime": "申请时间（起）：",
        "endCreateTime": "申请时间（止）：",
        "auditFlag": "审核状态：",
      }
      break;
    case 2:
    case 6:
      obj = {
        "orderNo": "订单号：",
        "merchantName": "商户名称：",
        "auditFlag": "支付状态：",
        "startDate": "申请时间（起）：",
        "endDate": "申请时间（止）：",
      }
      break;
    case 3:
    case 4:
      obj = {
        "orderNo": "订单号：",
        "payStatus": "支付状态：",
        "merchantName": "商户名称：",
        "bankAccountName": "来源账户名称：",
        "startDate": "申请时间（起）：",
        "endDate": "申请时间（止）：",
      }
      break;
    case 5:
      obj = {
        "merchantName": "商户名称：",
        "startTime": "发布时间（起）：",
        "endTime": "发布时间（止）：",
        "statusValue": "任务状态：",
      }
      break;
    case 8:
    case 9:
    case 11:
      obj = {
        "name": "商户名称：",
      }
      break;
    case 10:
      obj = {
        "orderNo": "交易流水号：",
        "startTime": "交易时间（起）：",
        "endTime": "交易时间（止）：",
        "balanceSubject": "支付类型：",
      }
      break;
    case 12:
      obj = {
        "merchantName": "商户名称：",
      }
      break;
    case 13:
      obj = {
        "name": "代理商名称：",
      }
      break;
    case 14:
      obj = {
        "name": "姓名：",
        "merchantName": "商户名称：",
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
        "preOrderWithAuth": "微信授权：",
      }
      break;
    case 15:
    case 16:
    case 25:
      obj = {
        "name": "姓名：",
      }
      break;
    case 15:
      obj = {
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
        "auditFlag": "注册状态：",
      }
      break;
    case 16:
      obj = {
        "type": "入驻类型：",
        "mobile": "手机号：",
      }
      break;
    case 17:
      obj = {
        "merchantName": "商户名称：",
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
        "auditFlag": "开票状态：",
      }
      break;
    case 19:
      obj = {
        "merchantName": "商户名称：",
        "billType": "查询方式：",
      };
      break;
    case 21:
      obj = {
        "merchantName": "商户名称：",
      }
      break;
    case 22:
      obj = {
        "merchantName": "商户名称：",
        "orderNo": "交易订单号：",
        "startCreateTime": "创建时间（起）：",
        "endCreateTime": "创建时间（止）：",
      }
      break;
    case 23:
      obj = {
        "startDate": "结算月份（起）：",
        "endDate": "结算月份（止）：",
        "auditFlag": "审核状态：",
      }
      break;
    case 24:
      obj = {
        "merchantName": "代理商名称：",
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
        "auditFlag": "审核状态：",
      }
      break;
    case 26:
      obj = {
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
        "balanceSubject": "交易类型：",
        "merchantName": "商户名称：",
      }
      break;
    case 28:
      obj = {
        "type": "数据保留/移除：",
        "startTime": "对账单日期（起）：",
        "endTime": "对账单日期（止）：",
        "merchantName": "商户名称：",
      }
      break;
    case 29:
      obj = {
        "merchantName": "商户名称：",
        "orderNo": "订单流水号：",
      }
      break;
    case 42:
      obj = {
        "merchantName": "代理商名称：",
        "startTime": "交易时间（起）：",
        "endTime": "交易时间（止）：",
        "balanceSubject": "交易类型：",
      }
      break;
    case 30:
    case 31:
    case 41:
      obj = {
        "orderNo": "订单号：",
        "bankAccountName": "账户名称：",
        "startDate": "申请时间（起）：",
        "endDate": "申请时间（止）：",
        "auditFlag": "订单状态：",
        "detailNo": "流水号：",
        "payStatus": "交易状态：",
        "receiptType": "电子回单状态：",
      }
      break;
    case 32:
      obj = {
        "startTime": "创建时间（起）：",
        "endTime": "创建时间（止）：",
      }
      break;
    case 33:
      obj = {
        "name": "姓名：",
        "startTime": "创建时间（起）：",
        "endTime": "创建时间（止）：",
        "auditFlag": "认证状态：",
        "checked": "关联状态：",
        "preOrderWithAuth": "微信授权：",
        "inviteType": "邀请类型：",
        "mobile": "邀请手机号：",
        "phone": "认证手机号：",
      }
      break;
    case 34:
      obj = {
        "bankAccountName": "账户名称：",
        "startDate": "申请时间（起）：",
        "endDate": "申请时间（止）：",
        "balanceSubject": "单据来源：",
      }
      break;
    case 35:
      obj = {
        "orderNo": "流水号：",
        "bankAccountName": "账户名称：",
        "startCreateTime": "申请时间（起）：",
        "endCreateTime": "申请时间（止）：",
        "startUpdateTime": "完成时间（起）：",
        "endUpdateTime": "完成时间（止）：",
        "auditFlag": "充值状态：",
      }
      break;
    case 36:
      obj = {
        "bankAccountName": "账户名称：",
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
      }
      break;
    case 37:
      obj = {
        "startTime": "对账单日期（起）：",
        "endTime": "对账单日期（止）：",
      }
      break;
    case 38:
      obj = {
        "auditFlag": "发票状态：",
        "startTime": "申请时间（起）：",
        "endTime": "申请时间（止）：",
        "billType": "发票类型：",
      }
      break;
    case 39:
      obj = {
        "orderNo": "充值订单号：",
        "bankAccountName": "账户名称：",
      }
      break;
  }
  return obj
}
window.typeValue = Vue.prototype.typeValue = function (data, type, value) {
  let objStr = ""
  if (value == "accountType") {
    objStr = accountIndexOf(configureInfos.accountTypeInfoArr, data);
  }
  if (type == 1 && value == "auditFlag") {
    objStr = accountIndexOf(configureInfos.auditFlagArray, data);
  }
  if ((type == 2 || type == 30) && value == "auditFlag") {
    objStr = accountIndexOf(configureInfos.auditFlagArr, data);
  }
  if (type == 3 || type == 4 || type == 31 || type == 41) {
    if (value == "payStatus") {
      objStr = accountIndexOf(configureInfos.payStatusSearchArr, data);
    }
    if (value == "paymentChannel") {
      objStr = accountIndexOf(configureInfos.payTypeInfoArr, data);
    }
    if (value == "payOfBankType") {
      objStr = data == "1" ? "银行卡" : objStr = data == "3" ? "微信" : "支付宝";
    }
    if (value == "isTransfer") {
      objStr = data == "1" ? "是" : "否";
    }

    if (value == "receiptType") {
      console.log(value)
      objStr = data == "0" ? "生成中" : "可下载";
    }
  }
  if (type == 5 || type == 32) {
    if (value == "taskStatus") {
      objStr = accountIndexOf(configureInfos.taskStatusArr, data);
    }
    if (value == "reviewStatus") {
      objStr = accountIndexOf(configureInfos.operateValueArr, data);
    }
  }
  if (type == 7) {
    if (value == "phaseStatus") {
      objStr = accountIndexOf(configureInfos.phaseStatusArr, data);
    }
  }
  if (type == 10) {
    if (value == "balanceSubject") {
      objStr = accountIndexOf(configureInfos.balanceSubArr, data);
    }
  }
  if (type == 11 || type == 12) {
    if (value == "customRelation") {
      objStr = data == "1" ? "未关联" : "已关联";
    }
  }
  if (type == 14) {
    if (value == "sourceType") {
      let obj = searchJson.sourceTypeObj;
      objStr = dataRegroup(data, obj).join("，");
    }
    if (value == "auditFlagType") {
      let obj = searchJson.auditFlagTypeObj;
      objStr = dataRegroup(data, obj).join("，");
    }
    if (value == "preOrderWithAuth") {
      objStr = data == "1" ? "已授权" : "未授权";
    }
  }
  if (type == 15 && value == "auditFlag") {
    objStr = accountIndexOf(options.selfOption, data);
  }
  if (type == 16) {
    if (value == "type") {
      objStr = accountIndexOf(options.typeOptions, data);
    }
    if (value == "isContact") {
      objStr = accountIndexOf(options.isContactArr, data);
    }
  }
  if (type == 17 && value == "auditFlag") {
    objStr = accountIndexOf(configureInfos.billAuditFlagArr, data);
  }
  if (type == 19 && value == "billType") {
    objStr = data == "0" ? "按账户查询" : "按服务商查询";
  }
  if (type == 20) {
    if (value == "isNotTax") {
      objStr = data == "1" ? "有个税" : "无个税";
    }
    if (value == "start") {
      objStr = data == "1" ? "已申报" : "未申报";
    }
  }
  if (type == 23 && value == "auditFlag") {
    objStr = accountIndexOf(configureInfos.settlAuditArray, data);
  }
  if (type == 24 && value == "auditFlag") {
    objStr = accountIndexOf(options.recordOption, data);
  }
  if (type == 25 && value == "status") {
    objStr = accountIndexOf(options.checkOption, data);
  }
  if (type == 26 && value == "refundStatus") {
    objStr = accountIndexOf(configureInfos.refundStatusArr, data);
  }
  if (type == 28 || type == 37) {
    if (value == "oderByType") {
      objStr = data == "0" ? "按时间排序" : "按商户排序";
    }
    if (value == "type") {
      objStr = data == "1" ? "保留" : "移除";
    }
    if (value == "amountType") {
      let obj = searchJson.amountTypeObj;
      objStr = dataRegroup(data, obj).join("，");
    }
    if (value == "accountType") {
      let obj = searchJson.accountTypeObj;
      objStr = dataRegroup(data, obj).join("，");
    }
  }
  if (type == 29) {
    if (value == "localStatus") {
      objStr = data == "2" ? "支付成功" : data == "3" ? "支付失败" : "";
    }
    if (value == "channel") {
      objStr = data == 9 ? "汇付宝支付" : data == 5 ? "支付宝支付" : "民生银行支付";
    }
    if (value == "billResult") {
      objStr = data == "1" ? "一致" : "不一致";
    }
    if (value == "checked") {
      objStr = data == "1" ? "一致" : data == "2" ? "不一致" : "未操作";
    }
  }
  if (type == 33) {
    if (value == "auditFlag") {
      objStr = accountIndexOf(configureInfos.signingStatusArr, data);
    }
    if (value == "checked") {
      objStr = data == "2" ? "已关联" : "未关联";
    }
    if (value == "preOrderWithAuth") {
      objStr = data == "1" ? "已授权" : data == "0" ? "未授权" : "";
    }
    if (value == "inviteType") {
      objStr = data == "1" ? "二维码邀请" : data == "2" ? "短信邀请" : "其他";
    }
  }
  if (type == 34) {
    if (value == "balanceType") {
      objStr = data == "1" ? "收入" : "支出";
    }
    if (value == "balanceSubject") {
      objStr = accountIndexOf(configureInfos.balanceSubjectArr, data);
    }
  }
  if (type == 35 && value == "auditFlag") {
    objStr = data == "0" ? "待审核" : data == "1" ? "已充值" : "已驳回";
  }
  if (type == 36 && value == "refundStatus") {
    objStr = accountIndexOf(configureInfos.refundStatusArr, data);
  }
  if (type == 38) {
    if (value == "auditFlag") {
      objStr = data == "0" ? "已提交" : data == "1" ? "已开票" : "已驳回";
    }
    if (value == "billType") {
      objStr = data == "1" ? "增值税普通电子发票" : "增值税专用电子发票";
    }
  }
  if (type == 42) {
    if (value == "balanceSubject") {
      objStr = accountIndexOf(configureInfos.balancejectArray, data);
    }
  }

  return objStr
}

function dataRegroup(data, obj) {
  let array = []
  if (data.length > 0) {
    data.forEach(element => {
      array.push(obj[element])
    });
  }
  return array
}

window.searchCriteria = Vue.prototype.searchCriteria = function (data, type) {
  let param = delEmptyQueryNodes(JSON.parse(data));
  let infoArr = [];
  for (var i in param) {
    if (searchJson.infoField[i]) {
      let strText = ""
      let array = ["bankAccountName", "startCreateTime", "endCreateTime", "auditFlag", "startDate", "endDate", "startTime", "endTime", "statusValue", "name", "balanceSubject", "orderNo", "merchantName", "payStatus", "billType", "type", "preOrderWithAuth", "checked", "inviteType", "mobile", "phone", "receiptType"];
      if (array.includes(i)) {
        strText = typeText(type)[i];
      } else {
        strText = searchJson.infoField[i];
      }

      let strVal = "";
      let typeArr = ["auditFlag", "accountType", "payStatus", "paymentChannel", "payOfBankType", "isTransfer", "taskStatus", "reviewStatus", "phaseStatus", "balanceSubject", "customRelation", "sourceType", "auditFlagType", "type", "isContact", "isNotTax", "start", "status", "refundStatus", "oderByType", "amountType", "billType", "localStatus", "channel", "billResult", "checked", "balanceType", "preOrderWithAuth", "inviteType", "receiptType"];

      if (typeArr.includes(i)) {
        strVal = typeValue(param[i], type, i);
      } else {
        strVal = param[i];
      }
      infoArr.push(Object.assign({label: strText, value: strVal}, param[i]))
    }
  }

  let params = "";
  for (var o in infoArr) {
    params += infoArr[o].label + infoArr[o].value + ";"
  }

  return params;
}
function delEmptyQueryNodes(obj) {
  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    if (value.length == 0) {
      delete obj[key];
    } else if (value === "" || value === null || value === undefined) {
      delete obj[key];
    }
  })
  return obj;
}



// WEBPACK FOOTER //
// ./src/utils/packag.js